export const BASE_URL = {
  production: 'https://thecollectiverse.com',
  staging: 'https://nft.staging.anotoys.com',
};
